import {
  NOTIFICACAO_ADMIN_LISTAR_DESTINATARIOS,
  NOTIFICACAO_ADMIN_CRIAR_DESTINATARIO,
  NOTIFICACAO_ADMIN_ATUALIZAR_DESTINATARIO,
  NOTIFICACAO_ADMIN_EXCLUIR_DESTINATARIO,
  NOTIFICACAO_ADMIN_OBTER_EVENTOS,
  NOTIFICACAO_ADMIN_SALVAR_EVENTOS,
  NOTIFICACAO_ADMIN_EMAIL_CONFIG,
  NOTIFICACAO_ADMIN_TEMPLATES_ESCOLHIDOS
} from "../actions/notificacoesAdministrativas";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const actions = {
  [NOTIFICACAO_ADMIN_LISTAR_DESTINATARIOS]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v4.notificacoesAdministrativas
        .listarDestinatarios(getters.getFornecedorId)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [NOTIFICACAO_ADMIN_CRIAR_DESTINATARIO]: (
    { dispatch },
    { idfornecedor, data }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v4.notificacoesAdministrativas
        .criarDestinatario(idfornecedor, data)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [NOTIFICACAO_ADMIN_ATUALIZAR_DESTINATARIO]: (
    { dispatch },
    { idfornecedor, id, data }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v4.notificacoesAdministrativas
        .atualizarDestinatario(idfornecedor, id, data)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [NOTIFICACAO_ADMIN_EXCLUIR_DESTINATARIO]: (
    { dispatch },
    { idfornecedor, id }
  ) => {
    return new Promise((resolve, reject) => {
      Api.v4.notificacoesAdministrativas
        .excluirDestinatario(idfornecedor, id)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [NOTIFICACAO_ADMIN_OBTER_EVENTOS]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v4.notificacoesAdministrativas
        .obterEventos(getters.getFornecedorId)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [NOTIFICACAO_ADMIN_SALVAR_EVENTOS]: ({ dispatch, getters }, eventos) => {
    return new Promise((resolve, reject) => {
      Api.v4.notificacoesAdministrativas
        .salvarEventos(getters.getFornecedorId, { eventos })
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [NOTIFICACAO_ADMIN_EMAIL_CONFIG]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.email
        .getConfig(getters.getFornecedorId)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },

  [NOTIFICACAO_ADMIN_TEMPLATES_ESCOLHIDOS]: ({ dispatch, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v2.marketing.email
        .getTemplatesEscolhidos(getters.getFornecedorId)
        .then(resp => {
          resolve(resp.data);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

export default {
  actions
};
